import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import { withStyles } from '../../mui-styles-bridge.js';
import { addPageData } from '../../store/form/actions';
import Autocomplete from '@mui/material/Autocomplete';
import TextFieldMUI from '@mui/material/TextField';

const styles = (theme) => ({
  checkbox: {
    color: '#afafaf',
    '&$checked': {
      color: '#2196F3',
    },
  },
  listtext: {},
  checked: {},
  root: {
    width: '100%',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
  },
});

class SingleSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = { single_select: '' };
  }

  componentDidMount() {
    let answer_data = this.props.form.answer_data[this.props.data.key];

    // First check if there's already an answer in the store
    if (answer_data && answer_data.answer && answer_data.answer[0]) {
      let answerValue;
      if (Array.isArray(answer_data.answer[0])) {
        // Answer is already in option format [value, label]
        answerValue = answer_data.answer[0][1];
      } else {
        // Answer is a simple value string (e.g., from URL prepopulation)
        // Try to find matching option by value (option[0])
        const matchingOption = this.props.data.data.find(
          (option) =>
            Array.isArray(option) && option[0] === answer_data.answer[0]
        );
        if (matchingOption) {
          answerValue = matchingOption[1]; // Use the label
        } else {
          // Also try matching by label directly
          const matchingByLabel = this.props.data.data.find(
            (option) =>
              Array.isArray(option) && option[1] === answer_data.answer[0]
          );
          answerValue = matchingByLabel
            ? matchingByLabel[1]
            : answer_data.answer[0];
        }
      }
      this.setState({
        single_select: answerValue,
      });
    }
    // Then check for auto values (prefilled values)
    else if (this.props.data.auto && this.props.data.auto.toString()) {
      const autoValue = Array.isArray(this.props.data.auto)
        ? this.props.data.auto[1]
        : this.props.data.auto;
      this.props.dispatchaddPageData(
        this.props.data.key,
        { single_select: autoValue },
        this.props.data.question_text
      );
      this.setState({ single_select: autoValue });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const currentAnswerInStore =
      this.props.form.answer_data[this.props.data.key];

    // Handle auto value changes (conditional prefills)
    // Auto values SHOULD overwrite user selections when conditions change
    const currentAuto = JSON.stringify(this.props.data.auto);
    const prevAuto = JSON.stringify(prevProps.data.auto);

    if (currentAuto !== prevAuto) {
      if (this.props.data.auto && this.props.data.auto.toString()) {
        const autoValue = Array.isArray(this.props.data.auto)
          ? this.props.data.auto[1]
          : this.props.data.auto;

        // Always set auto value when condition is met (override existing values)
        // This is intentional - conditional logic should take precedence
        this.props.dispatchaddPageData(
          this.props.data.key,
          { single_select: autoValue },
          this.props.data.question_text
        );
        this.setState({ single_select: autoValue });
      } else if (
        this.props.form.answer_data[this.props.data.key] &&
        this.props.form.answer_data[this.props.data.key].answer &&
        this.props.form.answer_data[this.props.data.key].answer[0]
      ) {
        // Clear selection when auto value is removed (condition no longer met)
        this.props.dispatchaddPageData(
          this.props.data.key,
          { single_select: '' },
          this.props.data.question_text
        );
        this.setState({ single_select: '' });
      }
    } else {
      // Handle user selection changes
      if (this.state.single_select + '' != prevState.single_select + '') {
        this.props.getDataFromComponent(
          { single_select: this.state.single_select },
          this.props.data.key,
          this.props.data.question_text,
          this.props.data.data
        );
      }
    }
  }

  handleChange = (event, inputValue) => {
    this.setState({ single_select: inputValue });
    this.props.getDataFromComponent(
      { single_select: inputValue },
      this.props.data.key,
      this.props.data.question_text,
      this.props.data.data
    );
  };

  doNothing = () => {};

  render() {
    const { classes, form, data } = this.props;
    const theme = createTheme({
      palette: {
        primary: { main: '#2196F3' },
      },
    });

    try {
      return (
        <div className={classes.root}>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <Autocomplete
                  className={'autocomplete'}
                  disabled={this.props.data.read_only}
                  id={`single-select-${this.props.data.key}`}
                  inputProps={this.props.data.style}
                  menuprops={{
                    getContentAnchorEl: null,
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                  }}
                  style={{ width: 'min-content !important' }}
                  options={this.props.data.data}
                  autoComplete={true}
                  value={this.state.single_select}
                  size={'small'}
                  onChange={
                    this.props.data.read_only
                      ? this.doNothing()
                      : (event, inputValue) => {
                          if (inputValue != null && Array.isArray(inputValue))
                            this.handleChange(event, inputValue[1]);
                        }
                  }
                  renderInput={(params) => {
                    return (
                      <TextFieldMUI
                        {...params}
                        variant="outlined"
                        value={this.state.single_select}
                      />
                    );
                  }}
                  getOptionLabel={(option) => {
                    if (Array.isArray(option)) {
                      if (option[1] == null) return '';
                      else return option[1];
                    } else return option;
                  }}
                  isOptionEqualToValue={(option, value) => {
                    if (option != null) {
                      if (Array.isArray(option)) {
                        return option[1] === value;
                      } else {
                        return option === value;
                      }
                    }
                    return false;
                  }}
                  variant={'outlined'}
                />
            </ThemeProvider>
          </StyledEngineProvider>
        </div>
      );
    } catch (e) {
      return <h5>Error encountered</h5>;
    }
  }
}

const mapStateToProps = (state, props) => {
  return {
    form: state.form,
  };
};

const mapDispatchToProps = {
  dispatchaddPageData: (key, answer, question_text) =>
    addPageData({ key, answer, question_text }),
};

SingleSelect.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SingleSelect));
